import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-worldmap',
  templateUrl: './worldmap.component.html',
  styleUrls: ['./worldmap.component.scss']
})
export class WorldmapComponent implements OnInit {
  lat: number = 51.673858;
  long: number = 7.815982;
  zoom: number = 8;
  constructor() { }

  ngOnInit(): void {
  }

}
